// Plan tiers and per-vessel feature resolution.
// Plan sets the default feature set; a vessel's `features` override wins per-module.

export const ALWAYS_ON = ['dashboard', 'chat', 'announcements']

export const ALL_MODULES = [
  'dashboard','chat','announcements','equipment','mlog','mtask','inventory','docs',
  'checklists','todo','lsa','risk_assessments','refit','budget','crew','calendar',
  'charters','port_calls','marina_bookings','hours_rest','watch_schedule','officer_review',
  'manuals','duty_rota','logbooks','weather','regulations','passage_plan',
  'reports','diary','rotations','bunkering','purchase_orders','apa','ism_audits','workspaces',
]

export const PLAN_FEATURES = {
  starter: [
    'dashboard','chat','announcements','equipment','mlog','mtask','inventory','docs',
    'checklists','todo','lsa','crew','calendar','logbooks','weather','diary',
  ],
  professional: [
    'dashboard','chat','announcements','equipment','mlog','mtask','inventory','docs',
    'checklists','todo','lsa','crew','calendar','logbooks','weather',
    'risk_assessments','hours_rest','watch_schedule','duty_rota','officer_review',
    'regulations','passage_plan','charters','port_calls','marina_bookings',
    'reports','manuals','diary','rotations','bunkering','purchase_orders','apa','ism_audits','workspaces',
  ],
  enterprise: ALL_MODULES,
}

// Resolve the effective feature set for a vessel config.
// - Start from the plan's default list
// - Apply per-vessel overrides in config.features ({ module: true|false })
// - ALWAYS_ON modules can never be turned off
export function effectiveFeatures(config) {
  const plan = (config?.plan || 'starter').toLowerCase()
  const base = new Set(PLAN_FEATURES[plan] || PLAN_FEATURES.starter)
  const overrides = config?.features || {}
  for (const [mod, on] of Object.entries(overrides)) {
    if (on) base.add(mod); else base.delete(mod)
  }
  for (const m of ALWAYS_ON) base.add(m)
  return base
}

// Is a module on for the login (pages, menu, guards)? Admin: everything. A management company looking at one of its
// vessels: THAT vessel's plan + overrides (the company login has no plan of its own - it fell back to Starter, which has no
// Purchase Orders, so the order waiting for management's approval could not be opened). The aliases are the guard's names:
// App.jsx guard(key) passes a permission key (permModules.js) to both can() and hasFeature(); where the two names differ
// the plan key is here ('documents' had none, so Survey Readiness was blank for every login).
export const FEATURE_ALIAS = { ai: 'chat', risk: 'risk_assessments', ptw: 'risk_assessments', passage: 'passage_plan', documents: 'docs', maintenance: 'mtask', marina: 'marina_bookings' }
export function featureOn(config, selectedVessel, module) {
  if (!config) return true
  if (config.accountType === 'admin' || config.is_admin) return true
  const feat = FEATURE_ALIAS[module] || module
  return effectiveFeatures(config.accountType === 'company' && selectedVessel ? selectedVessel : config).has(feat)
}

export function planLabel(plan) {
  return ({ starter:'Starter', professional:'Professional', enterprise:'Enterprise' })[(plan||'starter').toLowerCase()] || 'Starter'
}
